import axios from 'axios';

import { KanzhongBackend } from 'constant/KanzhongBackend';
import { ServerError, createApiError } from 'stores/ApiClientError';

// --- 型定義 ---

export type FinancialYearMonthResult = {
  financialYear: number;
  month: number;
  sortOrder: number;
  startDate: string;
  endDate: string;
  quarter: number;
};

export type FinancialYearResult = {
  financialYear: number;
  months: FinancialYearMonthResult[];
};

export type ListFinancialYearResponse = {
  results: FinancialYearResult[];
  current: FinancialYearMonthResult | null;
};

// --- API関数 ---

/**
 * 次年度登録API
 * リクエストボディなし。ADMINのみ実行可能。
 * すでに次年度が登録済みの場合は422エラー。
 */
export const createNextFinancialYear = async (): Promise<void> => {
  const sessionId = localStorage.getItem('session-id');

  try {
    await axios.post(
      KanzhongBackend.CREATE_NEXT_FINANCIAL_YEAR,
      {},
      {
        headers: {
          'X-Session-Id': sessionId,
        },
      },
    );
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      throw createApiError(status, data?.message || error.message);
    }
    throw new ServerError();
  }
};

/**
 * 年度一覧取得API
 * 登録されている全年度のデータと現在の年度月を返却する。
 * 権限: 認証のみ（権限不問）
 */
export const listFinancialYear = async (): Promise<ListFinancialYearResponse> => {
  const sessionId = localStorage.getItem('session-id');

  try {
    const response = await axios.get(KanzhongBackend.LIST_FINANCIAL_YEAR, {
      headers: {
        'X-Session-Id': sessionId,
      },
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      throw createApiError(status, data?.message || error.message);
    }
    throw new ServerError();
  }
};

/**
 * 年度取得API
 * @param financialYear - 年度（必須）
 * 権限: 認証のみ（権限不問）
 */
export const getFinancialYear = async (financialYear: number): Promise<FinancialYearResult> => {
  const sessionId = localStorage.getItem('session-id');

  try {
    const response = await axios.get(`${KanzhongBackend.GET_FINANCIAL_YEAR}/${financialYear}`, {
      headers: {
        'X-Session-Id': sessionId,
      },
    });

    return response.data.result;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      throw createApiError(status, data?.message || error.message);
    }
    throw new ServerError();
  }
};
